import React, { useState, useEffect } from "react";
import { Row, Col, Form } from "react-bootstrap";
import { MdEditor } from "Screens1/Common/MdEditor";
import * as actions from "Store/Course/Instructor/OtherLabs/Actions";
import parse from 'html-react-parser';
import '../../css/fillInBlanks.scss'; // Import the CSS file
import GradingDropdown from "../../GradeSubmission/GradingDropdown";
import httpService from 'services/httpService.js';
import * as constants from "Constants";
import displayGlobalMessage from "Utils/DisplayGlobalMessage";
import AnswerExplanation from "../../GradeSubmission/AnswerExplaination";
import GradeCheck from "../../GradeSubmission/GradeCheck";
// import { renderToString } from 'react-dom/server';
import {removeRemarks} from "../../GradeSubmission/GradeCheck";
import { useSelector } from "react-redux";
import log from "loglevel";


function Subjective(props) {
  const { courseId, question, index, previousResponse, updateResponse, disable, Eval } = props;
  const [questionResponseId, setQuestionResponseId] = useState(null);
  const [timer, setTimer] = useState(null);
  const [subj_text, setSubj_Text] = useState("");
  const userInfo = useSelector(state => state?.userInfo);
  const mode = userInfo.mode;
  
  useEffect(() => {
    if (previousResponse && !questionResponseId) {
      setQuestionResponseId(previousResponse.id);
      setSubj_Text(previousResponse.response_text); // Set subj_text with previous response text
    }
  }, [previousResponse]);

  const storeResponses = async (text) => {
    const inputValue = text;
    let response;
    if (!props.disable)
      response = await actions.addQuestionResponsesRequest(courseId, question, null, inputValue, questionResponseId, null);
    if (response) {
      setQuestionResponseId(response.id);
    }
    response={...response, id:question?.id}
    updateResponse(response);
  }

  const typingHandler = async (markdown) => {
    clearTimeout(timer);
    const value = markdown.text;
    setSubj_Text(value); // Update subj_text with the typed text
    const id = setTimeout(() => storeResponses(value), 1000);
    setTimer(id);
  }

  // const storeRemark = async (remark) => {
  //   const _response = await actions.addRemarkRequest(question, questionResponseId, remark);
  //   updateResponse();
  // }

  const storeScoredMarks = async (scored_marks) => {
    const response = await actions.addScoredMarksRequest(question, questionResponseId, scored_marks);
    updateResponse();
  }
  const handleSave = async (data) => {
    log.log('Grading Data:', data);
    if (data.marks > question?.marks) {
      displayGlobalMessage(`Question Grading failed: Invalid input: marks can't exceed ${question?.marks}`, 'error');
      return;
    } else {
      let url = constants.base_url + "/lab/activity/";
      let loc = location.pathname;
      let urlArray = loc.split('/');
      let user = userInfo.name || userInfo.username;
      let grade_data = {
        ...data,
        graded_by: user,
        question: question?.id,
        student_id: urlArray[urlArray.length - 1],
        otherlab: question?.otherlab,
        graded: true
      };
      log.log('graded data', grade_data);
      url = url + urlArray[urlArray.length - 3] + "?type=other_type_grade_submission";
      
      try {
        const response = await httpService.put(url, grade_data);
        log.log('response data:', response);
        if (response.status === 200) {
          displayGlobalMessage('Question Graded Successfully', 'success');
        } else {
          displayGlobalMessage('Question Grading failed', 'error');
        }
      } catch (error) {
        displayGlobalMessage('Question Grading failed', 'error');
        log.error(error);
      } finally {
        location.reload();
      }
    }
  };
  
  const q_text=removeRemarks(question?.question_text)
  return (
    <Row className="fill-blanks-component" style={{ margin: 10 }}>
     <Col xs={12} style={{marginBottom: 10}}>
  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '5px', borderBottom: '1px solid #ddd' }}>
    <b><i><span style={{fontSize:20, color: 'rgb(41, 121, 255)'} }>{`Question ${index + 1}`}</span></i></b>
    <span style={{ fontStyle: 'italic', fontWeight: 'bold', color: 'rgb(41, 121, 255)' }}>
    <i>Question Type: {question.question_type == 'D' ? 'Subjective' : ''} <span style={{ marginLeft: '40px' }}>Marks: {question.marks}</span></i>
    </span>
  </div>
</Col>
<Col xs={12}>
<b>{parse(`<p style={{ fontSize: '80px' }}>${q_text}</p>`)}</b>
</Col>

      <Col xs={12}>
        <div disabled={disable} style={Eval ? {border: (question?.marks === question?.questionresponse_set?.scored_marks)? '2px solid green' : (question?.questionresponse_set?.scored_marks>0)? '2px solid orange' : '2px solid red',backgroundColor: question?.marks === question?.questionresponse_set?.marks ? '#b9eddd' : '' }: {}}>
          <MdEditor
            onChange={(markdown) => typingHandler(markdown)}
            value={subj_text}
            disabled={disable}
          />
        </div>
      </Col>
      {disable === true ?
        <>
            <Col xs={6} />
          <Col xs={6}>
            <Form.Check>
              <Form.Label>Scored Marks</Form.Label>
              <Form.Control type="number" min='0' value={(Eval || mode === "I") ? question?.questionresponse_set?.scored_marks : 0} step='0.1' disabled />
             {/*} <Form.Label>Remarks</Form.Label>
              <Form.Control type="text" placeholder="Evaluation Remarks" defaultValue={previousResponse.remark} onBlur={(e) => storeRemark(e.target.value)} disabled />
              <Form.Control
                type="text"
                placeholder="Submit your crib"
      />*/}
            </Form.Check>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
      {mode === "I" ? (
        <div style={{marginRight:'-100px',marginTop:'-40px',marginLeft:'-250px'}}>
          <GradingDropdown onSave={handleSave} />
        </div>
      ) : Eval ? <div style={{marginRight:'-100px',marginTop:'-40px',marginLeft:'-250px'}}>
      <GradeCheck ques={question} />
    </div> : <></>}
      {(Eval || mode === "I") && (
        <div style={{marginRight:'-100px',marginTop:'-40px',marginLeft:'-450px'}}>
          <AnswerExplanation explanation={question?.answer_explaination} />
        </div>
      )}
    </div>
          </Col>
        </>
        :
        <></>
      }
    </Row>
  );
};

export default Subjective;
